import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UtilState } from '../reducers/util.reducer';

export const getUtilState = createFeatureSelector<UtilState>('util');

export const getAllKeywords = createSelector(getUtilState, (state: UtilState) => ({
  restrictedKeywords: state?.restrictedKeywords,
  restrictedSqlKeywords: state?.restrictedSqlKeywords,
  restrictedTableKeywords: state?.restrictedTableKeywords
}));

export const getKeywordsMeta = createSelector(getUtilState, (state: UtilState) => state?.keywordsMeta);
